import SectionMessage from '@atlaskit/section-message';
import CheckIcon from "../../../../../../packages/pragmatic-drag-and-drop/documentation/constellation/assets/check-icon";
import CrossIcon from "../../../../../../packages/pragmatic-drag-and-drop/documentation/constellation/assets/cross-icon";
import * as React from 'react';
export default {
  SectionMessage,
  CheckIcon,
  CrossIcon,
  React
};